import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { LoginService } from '../services/login.service';
import { StorageService } from '../services/storage.service';
@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate, CanLoad {

  constructor(
    private loginService: LoginService,
    private storageService: StorageService,
    private router: Router) {

  }

  canLoad(): Observable<boolean> {
    return this.loginService.isAuthenticated.pipe(
      filter(val => val !== null),
      take(1),
      map(isAuthenticated => {
        console.log('GUARD: ', isAuthenticated);
        if (isAuthenticated) {
          return true;
        }
        else {
          this.storageService.get('isRoutedFromACP').then(result => {
            if (result === true) {
              this.storageService.removeAll();
              window.close();
            }
            else {
              this.router.navigateByUrl('/login');
            }
          });
          return false;
        }
      })
    )
  }

  canActivate(): Observable<boolean> {
    return this.loginService.isAuthenticated.pipe(
      filter(val => val !== null),
      take(1),
      map(isAuthenticated => {
        console.log('GUARD: ', isAuthenticated);
        if (isAuthenticated) {
          return true;
        } else {
          this.storageService.get('isRoutedFromACP').then(result => {
            if (result === true) {
              this.storageService.removeAll();
              window.close();
            }
            else {
              this.router.navigateByUrl('/login');
            }
          });
          return false;
        }
      })
    )
  }
}
